import { deleteCookie } from './cookie';

export const clearAuthUserData = () => {
  sessionStorage.removeItem('user');
  sessionStorage.removeItem('authentication_result');
  localStorage.removeItem('user');
  localStorage.removeItem('authentication_result');
  deleteCookie('authentication_result');
};
